import { render, staticRenderFns } from "./VideoDetails.vue?vue&type=template&id=282fa3ab&scoped=true"
import script from "./VideoDetails.vue?vue&type=script&lang=js"
export * from "./VideoDetails.vue?vue&type=script&lang=js"
import style0 from "./VideoDetails.vue?vue&type=style&index=0&id=282fa3ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fa3ab",
  null
  
)

export default component.exports